import { render } from "./images.vue?vue&type=template&id=4ff70f9d&scoped=true"
import script from "./images.vue?vue&type=script&lang=js"
export * from "./images.vue?vue&type=script&lang=js"

import "./images.vue?vue&type=style&index=0&id=4ff70f9d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff70f9d"]])

export default __exports__